import { Icon } from '@buggy/shared'
import { Button } from 'antd'
import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import PermissionInsufficientTooltip from '@/components/common/permission-insufficient-tooltip'
import { useDirectoryActionPermission } from '@/hooks/use-permission'

interface InfoWrapperProps {
  title: string
  onClick?: () => void
  children?: ReactNode
  buttonPlacement?: 'left' | 'right'
}

export const InfoWrapper: FunctionComponent<InfoWrapperProps> = ({
  title,
  onClick,
  children,
  buttonPlacement = 'right',
}) => {
  const directoryActionPermission = useDirectoryActionPermission()

  return (
    <Wrapper>
      <ActionWrapper $buttonPlacement={buttonPlacement}>
        {!!onClick && (
          <PermissionInsufficientTooltip
            insufficient={!directoryActionPermission}
          >
            <Button
              disabled={!directoryActionPermission}
              icon={<Icon name='plus' />}
              onClick={onClick}
            >
              {title}
            </Button>
          </PermissionInsufficientTooltip>
        )}
      </ActionWrapper>
      <div>{children}</div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 16px 24px;
`

const ActionWrapper = styled.div<{ $buttonPlacement: 'left' | 'right' }>`
  margin: 0 0 16px 0;
  display: flex;

  justify-content: ${(props): string =>
    props.$buttonPlacement === 'right' ? 'flex-end' : 'flex-start'};
`
